import React from 'react';
import PropTypes from 'prop-types';
import {
    ListItemIcon,
    ListItemText,
    Menu,
    MenuItem,
    Tooltip
} from '@mui/material';
import CheckIcon from '@mui/icons-material/Check';
import DensitySmallIcon from '@mui/icons-material/DensitySmall';
import DensityMediumIcon from '@mui/icons-material/DensityMedium';
import DensityLargeIcon from '@mui/icons-material/DensityLarge';
import i18n from '../../../i18n';
import { DENSITY_ORDER, DEFAULT_DENSITY } from '../../../theme/density';
import ToolbarDropdownButton from '../../../components/toolbar/ToolbarDropdownButton';

const ICONS = {
    compact: DensitySmallIcon,
    standard: DensityMediumIcon,
    comfortable: DensityLargeIcon
};

/**
 * Row-height control for the grid. The preference is user-wide rather than
 * per-grid, so changing it here changes every grid.
 */
const DensityControl = ({ density, onChange }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);

    const handleClose = () => setAnchorEl(null);

    const handleSelect = (value) => {
        onChange(value);
        handleClose();
    };

    const CurrentIcon = ICONS[density] || ICONS.compact;

    return (
        <>
            <Tooltip title={i18n.t('common.density')}>
                <ToolbarDropdownButton
                    iconOnly
                    aria-label={i18n.t('common.density')}
                    icon={<CurrentIcon />}
                    open={Boolean(anchorEl)}
                    // Highlighted while rows are not at the default height,
                    // so a changed setting is visible without opening it.
                    active={density !== DEFAULT_DENSITY}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
                />
            </Tooltip>
            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
            >
                {DENSITY_ORDER.map((value) => {
                    const Icon = ICONS[value];
                    const selected = value === density;
                    return (
                        <MenuItem
                            key={value}
                            selected={selected}
                            onClick={() => handleSelect(value)}
                        >
                            <ListItemIcon>
                                {selected ? <CheckIcon /> : <Icon />}
                            </ListItemIcon>
                            <ListItemText>
                                {i18n.t(`density.${value}`)}
                            </ListItemText>
                        </MenuItem>
                    );
                })}
            </Menu>
        </>
    );
};

DensityControl.propTypes = {
    density: PropTypes.oneOf(DENSITY_ORDER),
    onChange: PropTypes.func.isRequired
};

export default DensityControl;
